import type { IEnvironment } from '~/interfaces/states/environment.state';

export const useEnvironment = () =>
  useState<IEnvironment>('environment', () => ref(useFetchEnvironment()));
